enum FetchStatus {
  UNFETCHED = 'UNFETCHED',
  FETCHED = 'FETCHED',
  FETCHING = 'FETCHING',
  ERROR = 'ERROR',
}

export default FetchStatus;
